import { createContext, useState } from "react";

export const InactiveDevicesReportContext = createContext();
const InactiveDevicesReportProvider = ({children}) =>{
    const [selectedTenantAdminProfile,setSelectedTenantAdminProfile] = useState(null);
    return(
        <InactiveDevicesReportContext.Provider value={{
            selectedTenantAdminProfile,setSelectedTenantAdminProfile
        }}>{children}</InactiveDevicesReportContext.Provider>
    );
};
export default InactiveDevicesReportProvider;